exports.networks = [ 
    {
        label: "Goerli", value : 5,
    }, {
        label: "Binance Smart Chain", value: 56,
    },{
        label: "Ethereum", value: 1, 
    }
]

exports.currencyTypes = [
    { label: "Primary Token", value: 1 },
    { label: "Native Token", value: 2 },
    { label: "Non Native Token", value: 3 }
]